import { useLocation } from 'react-router-dom'

import {
  CLIENT_HOME,
  CLIENT_MEDICATIONS,
  CLIENT_NOTES,
  CLIENT_PROGRESS,
  CLIENTS_SESSIONS,
} from '../../../common/constants/routingConstants'
import { ChatEntryPoint } from '../BaseChat'

export const useChatEntryPointFromRoute = (): ChatEntryPoint => {
  const { pathname } = useLocation()
  switch (pathname) {
    case CLIENT_HOME.route:
      return ChatEntryPoint.CLIENT_HOME
    case CLIENTS_SESSIONS.route:
      return ChatEntryPoint.CLIENT_SESSIONS
    case CLIENT_PROGRESS.route:
      return ChatEntryPoint.CLIENT_PROGRESS
    case CLIENT_NOTES.route:
      return ChatEntryPoint.CLIENT_NOTES
    case CLIENT_MEDICATIONS.route:
      return ChatEntryPoint.CLIENT_MEDICATIONS
    default:
      return ChatEntryPoint.CLIENT_HOME
  }
}
